/**
 * Fraîcheur du dernier relevé d'un compteur (refonte fiche bien, #651).
 *
 * Un relevé par an est le minimum ; au-delà, le compteur est signalé « à relever ».
 * Pur et sans Angular.
 */

export type ReadingFreshness =
  | { state: 'none' }
  | { state: 'fresh'; months: number }
  | { state: 'stale'; months: number };

/** Au-delà de ce nombre de mois sans relevé, le compteur est « à relever ». */
export const STALE_AFTER_MONTHS = 12;

function toDate(value: unknown): Date | null {
  if (value === null || value === undefined) {
    return null;
  }
  const maybeTimestamp = value as { toDate?: () => Date };
  const date =
    typeof maybeTimestamp.toDate === 'function'
      ? maybeTimestamp.toDate()
      : value instanceof Date
        ? value
        : new Date(value as string | number);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Mois entiers écoulés entre `from` et `to` (jamais négatif). */
function wholeMonthsBetween(from: Date, to: Date): number {
  let months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
  if (to.getDate() < from.getDate()) {
    months -= 1;
  }
  return Math.max(0, months);
}

export function readingFreshness(lastReadingDate: unknown, now: Date = new Date()): ReadingFreshness {
  const date = toDate(lastReadingDate);
  if (!date) {
    return { state: 'none' };
  }
  const months = wholeMonthsBetween(date, now);
  return months > STALE_AFTER_MONTHS ? { state: 'stale', months } : { state: 'fresh', months };
}
